<template>
    <b-modal ref="modal" title="AVISO DE PRIVACIDAD Y PROTECCIÓN DE DATOS" centered hide-footer>
      
<p>
    Al enviar este formulario, usted acepta que Referencia Laboratorio Clínico, S.A. recopile y trate sus datos personales para la gestión de servicios de laboratorio, programación de citas, envío de resultados y comunicaciones relacionadas con nuestros servicios.

</p>

<p>
    Usted se compromete a proporcionar información verídica y actualizada. Sus datos serán protegidos conforme a la Ley 172-13 sobre Protección de Datos de Carácter Personal de la República Dominicana.
</p>

<p>
    Usted tiene derecho a acceder, rectificar o cancelar sus datos personales en cualquier momento.
</p>

<p>
    Para más información, consulte nuestros Términos de Uso y Política de Privacidad.
</p>
  
  
      <div class="mt-3 d-flex justify-content-end">
        <button  type="button" class=" btn btn-secondary" @click="cancel" >
            Cancelar
        </button>

        <button type="button" class="m-10 btn btn-primary ms-3" @click="accept" >
            Aceptar
        </button>


      </div>
  
    </b-modal>
  </template>
  
  <script>
  export default {
    methods: {
      open() {
        this.$refs.modal.show();
      },
      accept() {
        this.$emit("accepted");
        this.$refs.modal.hide();
      },
      cancel() {
        this.$emit("cancelled");
        this.$refs.modal.hide();
      }
    }
  };
  </script>
  